import React from 'react';
import { useParams } from 'react-router-dom';
import MyProfile from './MyProfile';
import AccountSecurity from './AccountSecurity';
import NotificationPreferences from './NotificationPreferences';
import MyClients from './MyClients';
import McpServer from './McpServer';

// url segment → page; no segment = My profile
const tabs = [
    { path: '', component: MyProfile },
    { path: 'security', component: AccountSecurity },
    { path: 'notifications', component: NotificationPreferences },
    { path: 'mcp', component: McpServer },
    { path: 'clients', component: MyClients },
];

const Account: React.FC = () => {
    const { tab = '' } = useParams<{ tab?: string }>();
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    // each page renders its own .page-header (Save button differs per page) above the AccountNav row
    return <div className="v2-page account-v2">
        <current.component />
    </div>;
};

export default Account;
